import { render, staticRenderFns } from "./SelectSuggestion.vue?vue&type=template&id=edc86f60&"
import script from "./SelectSuggestion.vue?vue&type=script&lang=js&"
export * from "./SelectSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./SelectSuggestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edc86f60')) {
      api.createRecord('edc86f60', component.options)
    } else {
      api.reload('edc86f60', component.options)
    }
    module.hot.accept("./SelectSuggestion.vue?vue&type=template&id=edc86f60&", function () {
      api.rerender('edc86f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectSuggestion.vue"
export default component.exports